import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FhRequiredNotesComponent } from './components/fh-required-notes.component';
import { FhTextModule } from '@fh-client-interaction-frontends/fh-text';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [CommonModule, FhTextModule, TranslateModule],
  declarations: [FhRequiredNotesComponent],
  exports: [FhRequiredNotesComponent]
})
export class FhRequiredNotesModule {}
